module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAU9JREFUKBWdUjHLglAUPaUkZYVDWw3iokM0RXsSLi3+uMDdPQgHlyY3iWiLoIZwFkTIoRr06z5JjOz74jugvnvPOe/e97y17AH8A3zZ4/s+PM9Du91GvV4vqDRNkSQJptMpJpNJnqeKhDAMM8uy8uDDe7FYZFEUMRZPzXK5zIIgeIaV39PplDmOw7iin0cEQRCK9qoWxJOOwM64Wq1wOBwwHo+r9EXuer1iv9+z8zPjbrfD8XgEEb+BeCpwu93yioPBAPf7/Stjv9+HLMu5cTQa4Xw+w7ZtKIrysSh11Wq1QHp2OZqmodls/nk5pKFHVdXcKEkSOI5Dp9NBHMeVFSnf7XbRaDQgimLeKilN08R6vcZwOMRsNnszu67LLnA+nzOu+I/b7RaXywW6rr+ZKGEYButms9m8GmkWe73ey4yWd+B5nvG0OaFG81MWfLv+AWTK1Xy88tYIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/lounge.png
// module id = 511
// module chunks = 0